import { Component, ViewChild, ViewContainerRef, ComponentFactory } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})

export class ModalComponent {
  @ViewChild('dialogContainer', { read: ViewContainerRef, static: true }) dialogContainer: ViewContainerRef;

  constructor(public activeModal: NgbActiveModal) { }

  public setContent(contentFactory: ComponentFactory<any>): void {
    this.dialogContainer.clear();
    this.dialogContainer.createComponent(contentFactory);
  }
}
